import React, { useState } from 'react';
import { Button, Card, Space, Typography, message } from 'antd';
import UserAssignmentSelector from '../../component/excalidraw-bpmn/UserAssignmentSelector';

const { Title, Text } = Typography;

const UserAssignmentSelectorTest = () => {
  // 受控模式状态
  const [controlledValue, setControlledValue] = useState({
    type: 'static_user',
    label: '指定用户',
    isDynamic: false,
    users: [
      {
        Id: "9",
        Name: "李元辉",
        Username: "15812001304",
        Phone: "15812001304"
      },
      {
        Id: "1",
        Name: "管理员",
        Username: "13769181072",
        Phone: "13769181072"
      }
    ]
  });
  const [controlledVisible, setControlledVisible] = useState(false);

  // 非受控模式状态
  const [uncontrolledVisible, setUncontrolledVisible] = useState(false);
  const [uncontrolledResult, setUncontrolledResult] = useState(null);

  // 受控模式处理函数
  const handleControlledChange = (value) => {
    console.log('受控模式 onChange:', value);
    setControlledValue(value);
    setControlledVisible(false);
    message.success('受控模式值已更新');
  };

  // 非受控模式处理函数
  const handleUncontrolledConfirm = (value) => {
    console.log('非受控模式 onConfirm:', value);
    setUncontrolledResult(value);
    setUncontrolledVisible(false);
    message.success('非受控模式值已获取');
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>UserAssignmentSelector 测试页面</Title>
      
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        {/* 受控模式测试 */}
        <Card title="受控模式测试" style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Text strong>当前值:</Text>
            <pre style={{ background: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
              {JSON.stringify(controlledValue, null, 2)}
            </pre>
            <Button 
              type="primary" 
              onClick={() => setControlledVisible(true)}
            >
              打开受控模式选择器
            </Button>
          </Space>
        </Card>

        {/* 非受控模式测试 */}
        <Card title="非受控模式测试" style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Text strong>返回结果:</Text>
            <pre style={{ background: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
              {uncontrolledResult ? JSON.stringify(uncontrolledResult, null, 2) : '暂无结果'}
            </pre>
            <Button 
              type="primary" 
              onClick={() => setUncontrolledVisible(true)}
            >
              打开非受控模式选择器
            </Button>
          </Space>
        </Card>
      </Space>

      {/* 受控模式选择器 */}
      <UserAssignmentSelector
        visible={controlledVisible}
        value={controlledValue}
        onChange={handleControlledChange}
        onCancel={() => setControlledVisible(false)}
      />

      {/* 非受控模式选择器 */}
      <UserAssignmentSelector
        visible={uncontrolledVisible}
        initialValue={{
          type: 'static_role',
          roles: [{ id: 1, name: '测试角色1' }]
        }}
        onConfirm={handleUncontrolledConfirm}
        onCancel={() => setUncontrolledVisible(false)}
      />
    </div>
  );
};

export default UserAssignmentSelectorTest;